import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../login.service';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { LoadingService } from '../../../auxiliares/servicios/loading.service';
import { DialogService } from '../../../auxiliares/dialog/dialog.service';
import { EnvService } from '../../../env';

@Component({
  standalone: false,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private login = inject(LoginService);
  helper = inject(HelperService);
  loading = inject(LoadingService);
  private dialogService = inject(DialogService);
  envService = inject(EnvService);

  public form?: FormGroup;
  public token?: string;
  public inputType = 'password';
  public confirmInputType = 'password';

  private buildForm() {
    this.form = new FormGroup({
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
      ]),
      confirmPassword: new FormControl('', [Validators.required]),
    });

    // Agregar validación cuando cambie cualquier campo
    this.form.get('confirmPassword')?.valueChanges.subscribe(() => {
      this.checkPasswordMatch();
    });
    this.form.get('password')?.valueChanges.subscribe(() => {
      this.checkPasswordMatch();
    });
  }

  private checkPasswordMatch() {
    const password = this.form?.get('password')?.value;
    const confirmPassword = this.form?.get('confirmPassword')?.value;

    if (confirmPassword && password && password !== confirmPassword) {
      this.form?.get('confirmPassword')?.setErrors({ passwordMismatch: true });
    } else if (
      this.form?.get('confirmPassword')?.errors?.['passwordMismatch']
    ) {
      const errors = { ...this.form?.get('confirmPassword')?.errors };
      delete errors['passwordMismatch'];
      this.form
        ?.get('confirmPassword')
        ?.setErrors(Object.keys(errors).length ? errors : null);
    }
  }

  public onClickShowPassword() {
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
  }

  public onClickShowConfirmPassword() {
    this.confirmInputType =
      this.confirmInputType === 'password' ? 'text' : 'password';
  }

  public goBackToLogin() {
    this.router.navigateByUrl('/login');
  }

  public async onSubmit() {
    if (!this.form?.valid || !this.token) {
      return;
    }

    const res = await this.dialogService.confirm(
      'Cambio de contraseña',
      '¿Confirmás que querés cambiar la contraseña?',
      'Confirmar',
      'Cancelar',
    );
    if (!res) {
      return;
    }

    this.loading.setLoading(true);
    try {
      const password = this.form?.get('password')?.value;
      const result = await this.login.changePassword(this.token, password);
      this.helper.notifSuccess(result.message);
      this.router.navigateByUrl('/login');
    } catch (error: any) {
      console.error(error);
      if (error.error?.message) {
        this.helper.notifError(error.error.message);
      } else {
        this.helper.notifError('Error al cambiar la contraseña');
      }
    }
    this.loading.setLoading(false);
  }

  ngOnInit(): void {
    this.buildForm();

    // Capturar token del query param
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
      if (!this.token) {
        this.helper.notifError('Token inválido o expirado');
        this.router.navigateByUrl('/login');
      }
    });
  }
}
